export interface Instance {
  instance: string;
  type: TypeEnum;
}

export enum TypeEnum {
  Medical = "medical",
  User = "user",
  Logs = "logs",
}
